<div
  class="h-20 md:h-24 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 w-full top-0 fixed z-[1000] py-3 md:py-4 bg-white justify-between items-center mx-auto flex border-b border-[#D4D4D4]"
  style="left: 0px; background-color: #ffffff;">
  <div class="flex items-center justify-between md:w-auto w-full h-full">
    <a routerLinkActive="active" ariaCurrentWhenActive="page" class="
        h-full
        items-center
        LeadingIconLUseHighEmphasis justify-start gap-0.5 flex cursor-pointer">

      @switch (site) {
      @case ('skavsta') {
      <img class="max-h-full max-w-[195px]" (click)="gotToBooking('skavsta')"
        src="../../../../../assets/img/skavsta-logo.png" />
      }
      @case ('flygets') {
      <img class="w-[195px]" (click)="gotToBooking('flygets')"
        src="../../../../../assets/img/thumbnail_Flygets-logo.png" />
      }
      @case ('mdpark') {
      <img style="background-color: lightsteelblue;" (click)="gotToBooking('mdpark')" class="max-h-full max-w-[195px]"
        src="../../../../../assets/img/mdpark_logo.png" />
      }
      @case ('nazar') {
      <img class="max-h-full max-w-[125px]" (click)="gotToBooking('nazar')"
        src="../../../../../assets/img/nasar_logo.png" />
      }
      @case ('tui') {
      <img class="max-h-full max-w-[125px]" (click)="gotToBooking('tui')"
        src="../../../../../assets/img/SE_TUI_3CPM_transparent_blue_Co_coop.png" />
      }
      @case ('quality-xpo-arlanda') {
      <img class="max-w-[200px] max-h-[52px] md:max-h-[60px] w-auto object-contain cursor-pointer"
        (click)="gotToBooking('quality-xpo-arlanda')"
        src="../../../../../assets/img/quality-hotel-airport-arlanda.svg" />
      }
      @case ('quality') {
      <img class="max-w-[200px] max-h-[52px] md:max-h-[60px] w-auto object-contain cursor-pointer"
        (click)="gotToBooking('quality-xpo-arlanda')"
        src="../../../../../assets/img/quality-hotel-airport-arlanda.svg" />
      }
      @case ('aiden-short-term') {
      <img class="max-w-[170px] max-h-[65px] md:max-h-[75px] w-auto object-contain cursor-pointer"
        (click)="gotToBooking('aiden')" src="../../../../../assets/img/Aiden-hotel-logo.svg" />
      }
      @case ('aiden') {
      <img class="max-w-[170px] max-h-[65px] md:max-h-[75px] w-auto object-contain cursor-pointer"
        (click)="gotToBooking('aiden')" src="../../../../../assets/img/Aiden-hotel-logo.svg" />
      }
      @default {
      <svg width="195" height="23" viewBox="0 0 195 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 22.9V0H15.4158C18.3835 0 20.1147 0.5 21.2688 1.6C22.4229 2.8 23 4.9 23 8.4C23 11.3 22.8351 13.5 21.8459 15C20.9391 16.5 19.2079 17.1 16.405 17.1H7.99642V12H14.1792C16.3226 12 17.4767 11.5 17.4767 8.7C17.4767 7.2 17.2294 6.3 16.5699 5.8C15.9928 5.3 15.1685 5.2 14.0143 5.2H5.35842V23H0V22.9Z"
          fill="#29ABE2" />
        <path
          d="M44.2139 22.9L42.7514 18.6H32.3815L30.8526 22.9H26L34.5087 0H40.6908L49 22.9H44.2139ZM33.8439 14.4H41.2225L37.5 4.1L33.8439 14.4Z"
          fill="#29ABE2" />
        <path
          d="M69.4863 22.9V21C69.4863 18.4 69.3288 16.9 66.8082 16.9H59.8767V11.8H66.6507C68.1473 11.8 68.7774 11.6 69.25 11C69.7226 10.4 69.7226 9.4 69.7226 8.2C69.7226 7 69.6438 5.8 68.4623 5.3C67.911 5.1 67.2021 5.1 66.8082 5.1H57.1199V11.8V16.9V22.9H52V0H69.0137C71.2979 0 72.637 0.5 73.5822 1.5C74.5274 2.6 75 4.4 75 7.1C75 8.7 74.9212 10.4 74.2911 11.8C73.7397 12.9 72.7158 13.3 71.7705 13.7C71.613 13.8 71.3767 13.8 71.2192 13.9L71.2979 14.5C73.5822 14.9 74.8425 15.7 74.8425 18.7V22.9H69.4863Z"
          fill="#29ABE2" />
        <path d="M78 22.9V0H84.5V6.7V7V17.9V22.9H78Z" fill="#29ABE2" />
        <path
          d="M99.3 22.9L89 14.1L88.9 14C88 13.4 87.5 12.5 87.5 11.4C87.5 10.3 88 9.4 88.9 8.8L89 8.7L98.5 0H107.4L94.3 11.3L108.8 22.9H99.3Z"
          fill="#29ABE2" />
        <path d="M118.301 0H111.801V22.9H118.301V0Z" fill="#29ABE2" />
        <path d="M121.301 22.9V0H144.301V4.7H127.69V9.8H143.023V13.8H127.69V22.9H121.301Z" fill="#0583C9" />
        <path d="M147.301 22.9V0H154.461V17.6H170.301V22.9H147.301Z" fill="#0583C9" />
        <path d="M178.184 23V14.9651L167.301 0H174.113L180.842 9.94323L187.572 0H194.301L183.584 14.9651V23H178.184Z"
          fill="#0583C9" />
      </svg>
      }
      }
    </a>

    <div class="flex md:hidden items-center gap-2">
      <button class="w-[40px] h-[40px] flex items-center justify-center cursor-pointer" (click)="toggleLanguage()">
        <img src="{{languageImageSource}}" alt="toggle language" class="w-[24px] h-[24px]">
      </button>
      <div class="flex items-right">
        <button class="mobile-menu-button flex items-center justify-center" (click)="toggleLeftNav()" mat-icon-button
          [matMenuTriggerFor]="mobileMenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <title>bars-3-bottom-left</title>
            <g fill="none">
              <path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" stroke="white" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"></path>
            </g>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div [ngClass]="{hidden: isLeftNavHidden}"
    class="Frame502 justify-start items-center gap-4 hidden md:flex md:flex-row flex-col mt-3 md:mt-0">
  </div>

  <div class="hidden md:flex items-center gap-3 md:gap-4 lg:gap-6 flex-nowrap">
    @if (!authService.loggedIn()) {
    <button
      class="text-xs sm:text-sm whitespace-nowrap text-white border-2 border-primary rounded-[4px] px-3 sm:px-4 md:px-5 lg:px-8 py-1.5 sm:py-2 font-semibold hover:underline bg-[#1B3777] transition-all"
      (click)="login()">
      {{"FORM.LOGIN" | transloco}}
    </button>
    }
    <button
      class="text-xs sm:text-sm whitespace-nowrap text-color border-2 border-primary rounded-[4px] px-3 sm:px-4 md:px-5 lg:px-8 py-1.5 sm:py-2 font-semibold hover:underline transition-all"
      (click)="goToHandleBooking()">
      {{"PARKIFLY.HOME.MANAGE_BOOKING" | transloco}}
    </button>
    <button class="hidden md:flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity"
      (click)="toggleLanguage()">
      <img src="{{languageImageSource}}" alt="toggle language" class="w-[24px] h-[24px] block">
    </button>
    @if (authService.loggedIn()) {
    <button type="button" class="flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer"
      [matMenuTriggerFor]="menu" title="Account Menu">
      <mat-icon class="navbar-menu">account_circle</mat-icon>
    </button>
    }
  </div>
</div>

<mat-menu #mobileMenu="matMenu">
  @if (!authService.loggedIn()) {
  <button mat-menu-item (click)="login()">
    <mat-icon>login</mat-icon>
    <span>{{"FORM.LOGIN" | transloco}}</span>
  </button>
  }
  @if (authService.loggedIn()) {
  <button mat-menu-item (click)="goToOrders()">
    <mat-icon>format_list_bulleted</mat-icon>
    <span>{{"NAVIGATION.ORDERS" | transloco}}</span>
  </button>
  }
  <button mat-menu-item (click)="goToHandleBooking()">
    <mat-icon>manage_accounts</mat-icon>
    <span>{{"PARKIFLY.HOME.MANAGE_BOOKING" | transloco}}</span>
  </button>
  @if (authService.loggedIn()) {
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>{{"NAVIGATION.SIGN_OUT" | transloco}}</span>
  </button>
  }
</mat-menu>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="goToOrders()">
    <mat-icon>format_list_bulleted</mat-icon>
    <span>
      {{ 'NAVIGATION.ORDERS' | transloco }}
    </span>
  </button>
  <button mat-menu-item (click)="logout()" matTooltip="Logga ut">
    <mat-icon>login</mat-icon>
    <span>
      {{ 'NAVIGATION.SIGN_OUT' | transloco }}
    </span>
  </button>
</mat-menu>